import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isAdditionalDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { EntitiesByLei } from 'store/ducks/Reportings/types';
import { entitiesByLei } from 'components/Columns/EntitiesByLei';

interface reportDataProps {
  entityName: string;
}

const EntitiesByFinancialLei: React.FC<reportDataProps> = ({ entityName }) => {
  const { date, is_additional_displayed, financial_entity_lei_id } =
    useSelector((state: RootState) => state.reportings);
  const [data, setData] = useState<EntitiesByLei[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isAdditionalDisplayed(false));
    const params = {
      financial_entity_lei: financial_entity_lei_id,
      date,
    };

    try {
      const fetchedData = await reportingOp.fetchEntitiesByFinancialLei(params);
      if (fetchedData && Array.isArray(fetchedData.entities)) {
        const formattedData = fetchedData.entities.map(
          (dataItem: any, index: number) => ({
            key: index,
            name_of_entity: dataItem.name_of_entity,
            lei_maintaining_register: dataItem.lei_maintaining_register,
            head_office_lei: dataItem.head_office_lei,
            financial_reporting_date: dataItem.financial_reporting_date,
            financial_entity_type_name: dataItem.financial_entity_type_name,
            financial_entity_name: dataItem.financial_entity_name,
            financial_country_name: dataItem.financial_country_name,
            financial_competent_authority_name:
              dataItem.financial_competent_authority_name,
            entity_start_date: dataItem.entity_start_date,
            entity_end_date: dataItem.entity_end_date,
            branch_start_date: dataItem.branch_start_date,
            branch_name: dataItem.branch_name,
            branch_identification_code: dataItem.branch_identification_code,
            branch_end_date: dataItem.branch_end_date,
            branch_competent_authority: dataItem.branch_competent_authority,
          }),
        );
        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (financial_entity_lei_id) {
      fetchData();
    }
  }, [is_additional_displayed, financial_entity_lei_id]);

  return (
    <>
      <Table
        columns={entitiesByLei}
        dataSource={data}
        scroll={{ x: 1000, y: 430 }}
      />
    </>
  );
};

export default EntitiesByFinancialLei;
